'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var doe_white_seal_inline = require('../../../assets/svg/doe_white_seal.inline.svg.js');

var nnsa_logo_inline = require('../../../assets/svg/nnsa_logo.inline.svg.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var FooterSponsor = function FooterSponsor() {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "lanl-ft-sponsor-col",
    className: "lanl-footer-div link-links-col"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sponsor-logo-container"
  }, /*#__PURE__*/React__default['default'].createElement(doe_white_seal_inline['default'], {
    className: "doe-image",
    "data-testid": "doe-seal",
    viewBox: "0 0 290.335 72.372"
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sponsor-logo-container"
  }, /*#__PURE__*/React__default['default'].createElement(nnsa_logo_inline['default'], {
    className: "NNSA-image",
    "data-testid": "nnsa-seal",
    viewBox: "0 0 150 43.279"
  })));
};

exports.FooterSponsor = FooterSponsor;
exports['default'] = FooterSponsor;